/**
 * Created by ljy on 07/09/19
 */
// 组织机构类型
// let orgType = (val, type) => {
//     if (type === 'apply') {
//         switch (val) {
//             case '1':
//                 return '预警应用模型'
//             case '2':
//                 return '性能应用模型'
//         }
//     } else {
//         switch (val) {
//             case '1':
//                 return '预警模型'
//             case '2':
//                 return '性能模型'
//         }
//     }
// }
// 组织机构类型
let orgType = val => {
  switch (val) {
    case '1':
      return '集团'
    case '2':
      return '片区'
    case '3':
      return '园所'
    case '4':
      return '部门'
    default:
      return ''
  }
}

// 账单管理、移费申请记录、移费审批里【移费审批状态】
// 内部转账申请、内部转账审批、往来申请、往来审批里【审批状态】
let accountApproveState = val => {
  switch (val) {
    case -1:
      return '未提交'
    case 0:
      return '审核中'
    case 1:
      return '审核通过'
    case 2:
      return '驳回'
    case 5:
      return '已撤销'
    case 6:
      return '已作废'
    case 7:
      return '无需审批'
    default:
      return '无移费'
  }
}

// 内部转账申请、内部转账审批、往来申请、往来审批里【支付状态】
let cashPayStateName = val => {
  switch (val) {
    case 0:
      return '未支付'
    case 1:
      return '已支付'
    default:
      return ''
  }
}

// 内部转账申请、内部转账审批【转账类型】
let transferTypeName = val => {
  switch (val) {
    case 1:
      return '预算拨款申请'
    case 2:
      return '非预算拨款申请'
    default:
      return ''
  }
}

// 往来申请、往来审批【业务类型、往来类型】
let businessStateName = val => {
  switch (val) {
    case 2:
      return '收款'
    case 1:
      return '付款'
    default:
      return ''
  }
}

let transferStateName = val => {
  switch (val) {
    case 2:
      return '还款'
    case 3:
      return '上缴利润'
    case 1:
      return '借款'
    case 4:
      return '其他'
    default:
      return ''
  }
}

// 账单管理、移费申请记录、移费审批里 【发送状态】
let sendStateName = val => {
  if (val === '2') {
    return '未发送'
  } else if (val === '0') {
    return '发送成功'
  } else if (val === '1') {
    return '发送失败'
  }
}

// 账单管理、移费申请记录、移费审批里 【支付状态】
let payStateName = (payState, priceTotal) => {
  if (priceTotal >= 0) {
    if (payState === '0') {
      return '未支付'
    } else if (payState === '1') {
      return '已支付'
    } else if (payState === '2') {
      return '已作废'
    } else if (payState === '3') {
      return '已超期'
    } else if (payState === '4') {
      return '支付中'
    }
  } else if (priceTotal < 0) {
    if (payState === '0') {
      return '未退费'
    } else if (payState === '1') {
      return '已退费'
    } else if (payState === '2') {
      return '已作废'
    } else if (payState === '3') {
      return '已超期'
    } else if (payState === '4') {
      return '退费中'
    }
  }
}

export function moneyFmt (val) {
  if (val || val === 0) {
    return fmoney(val, 2)
  }
}

// 格式化 金额字段
let moneyStr = val => {
  if (val || val === 0) {
    return fmoney(val, 2)
  }
}
// 格式化 金额，按照3位数加‘，’方式
function fmoney (s, n) {
  if (s === null || s === '') {
    return ''
  }
  s = parseFloat((s + '')).toFixed(n) + ''
  var b = false
  if (s.toString().indexOf('-') > -1) {
    b = true
    s = s.substring(1, s.length)
  }
  var l = s.split('.')[0].split('').reverse()
  var r = s.split('.')[1]
  let t = ''
  for (var i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
  }
  if (b) {
    return '-' + t.split('').reverse().join('') + '.' + r
  } else {
    return t.split('').reverse().join('') + '.' + r
  }
}

let formatDate = time => {
  let t = new Date(time)
  let Y = t.getFullYear() < 10 ? '0' + t.getFullYear() : t.getFullYear()
  let M = t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  let D = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  return Y + '.' + M + '.' + D
}
let formatDate2 = time => {
  let t = new Date(time)
  let Y = t.getFullYear() < 10 ? '0' + t.getFullYear() : t.getFullYear()
  let M = t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  let D = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  return Y + '-' + M + '-' + D
}
let formatDatetime = time => {
  let t = new Date(time)
  let Y = t.getFullYear() < 10 ? '0' + t.getFullYear() : t.getFullYear()
  let M = t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  let D = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  let H = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
  let m = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
  return `${Y}-${M}-${D} ${H}:${m}`
}

export {
  orgType,
  moneyStr,
  fmoney,
  formatDate,
  formatDate2,
  formatDatetime,
  accountApproveState,
  sendStateName,
  payStateName,
  cashPayStateName,
  transferTypeName,
  businessStateName,
  transferStateName
}



// WEBPACK FOOTER //
// ./src/utils/filters.js